import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import {  useTranslation } from 'react-i18next';
import DataTable from "react-data-table-component";
import { downloadFile, getAxiosResponse, putAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import Constants from "../../Constants";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { currentDateWithFormat } from "../../services/Util";
import ImportBulkUsers from "./ImportBulkUsers";
import { useSelector } from "react-redux";
import $, { event } from "jquery";
import { getLoggedInUserRole } from "../../services/Util";
import { Breadcrumb } from "../../components/dashboard/Breadcrumb";
import { handleError } from "../../services/authApiRoutes/APImethods";
import { ConditionalBlock } from '../../ConditionalBlock';

export default function UserManagement() {
    const scrollRef = useRef(null);
    const { t } = useTranslation();
    const translate = t;
    const navigate = useNavigate();
    const [rightModal, setRightModal] = useState(false);

    const [users, setUsers] = useState([]);
    const [loader, showLoader] = useState(false);
    const [userStatus, setUserStatus] = useState('');
    const [userStatusInfo, setUserStatusInfo] = useState('');
    const [userActivationStatus, updateUserActivationStatus] = useState('');
    const [viewDetails, setViewDetails] = useState('');
    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, updateSelectedDepartment] = useState({label: '', value: ''});
    const [userRole, setUserRole] = useState([]);
    const [selectedUserRole, updateSelectedUserRole] = useState({label: '', value: ''});
    const [reviewLanguages, setReviewLanguages] = useState([]);
    const [selectedReviewLanguage, updateSelectedReviewLanguage] = useState({label: '', value: ''});
    const [selectedAccountStatus, updateSelectedAccountStatus] = useState({label: '', value: ''});
    const [nameFilter, updateNameFilter] = useState('');
    const [emailFilter, updateEmailFilter] = useState('');
    const [showBulkImportUsers, setShowBulkImportUsers] = useState(false);
    const [customerEnforcesUserLimit, setCustomerEnforcesUserLimit] = useState(false);
    const [roleTypeLimitList, setRoleTypeLimitList] = useState([]);
    const [limitRemain, setLimitRemain] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(25);
    const [currentFilterRequestVersion, setCurrentFilterRequestVersion] = useState(1);
    const buttonRef = useRef()
    const deactivateButtonRef = useRef()
    const activateButtonRef = useRef()
    const roleArray = getLoggedInUserRole();
    const paginationRef = useRef();
    const [filterUrl, setFilterUrl] = useState('');


    const owner = useSelector(
      (loginSessionDetail) => loginSessionDetail.loginSession
    ).value

    const customerBootstrapData = useSelector(reduxStore => reduxStore.customer_bootstrap_data).value;

    const showModel = (e, userId) => {
      setUserStatus(`${t('user_deactivate')}`);
      setUserStatusInfo(`${t('user_deactivate_confirm_message')}`)
      updateUserActivationStatus(userId);
      document.body.classList.add("modal-open");

      deactivateButtonRef.current = e.target;
      setTimeout(() => {
        $("#close-popup").trigger("focus");
      }, 300);

      $(document).keydown(function(event) {
        if (event.keyCode == Constants.ESC_KEYCODE) {
          hideModel();
        }
      });
    };
    const hideModel = () => {
      document.body.classList.remove("modal-open");
      if($(deactivateButtonRef.current).length)
       {$(deactivateButtonRef.current).parent().trigger('focus')};

    };

     const traceFocus = (event) => {
    if (
      document.activeElement.id === "active-popup-id" &&
      event.keyCode === Constants.TAB_KEYCODE &&
      event.shiftKey === false
    ) {
      event.preventDefault();
        $("#close-popup").trigger("focus");
    }
  };
    const showRightModel = (e) => {

      setViewDetails(e.target.id);
      buttonRef.current = e.target;
    
      setRightModal(true);
      document.body.classList.add("right-modal-open");
      
      setTimeout(() => {
        $("#close-right-modal").trigger("focus");
      }, 300);

      $(document).keydown(function(event) {
        if(document.activeElement.id === 'close-right-modal' && event.keyCode === Constants.TAB_KEYCODE) {
          event.preventDefault();
          $("#close-right-modal").trigger("focus");
        }

        if (event.key == Constants.ESCAPE ) {
          hideRightModel();
        }
        
      });
    };

    const hideRightModel = () => {
      setRightModal(false);
      document.body.classList.remove("right-modal-open");
      if(buttonRef.current) {buttonRef.current.focus()};
        };

    const showActivateModel = (e, userId) => {
      setUserStatus(`${t('user_activate')}`);
      setUserStatusInfo(`${t('user_activate_confirm_message')}`);
      updateUserActivationStatus(userId);
      document.body.classList.add("modal-open");
      deactivateButtonRef.current = e.target;
      
      setTimeout(() => {

        $("#close-popup").trigger("focus");
      }, 300);

      $(document).keydown(function(event) {
        if (event.key == Constants.ESC_KEYCODE) {
          hideModel();
        }
      });

    }

    const incrementFilterRequestVersion = () => {
      setCurrentFilterRequestVersion(currentFilterRequestVersion + 1);
    }

    const updateActivation = (updateType, userToUpdate, e) => {
      if(updateType === Constants.ACTIVATE) {
        setEnabled(userToUpdate, true);
      } else {
        setEnabled(userToUpdate, false);
      }

      $(".lastdisable").trigger("focus");


    }

    const openEditUserProfile = (userId) => {
      navigate("/settings/my-account-profile/"+userId);
    }

    const setEnabled = (id, enabled) => {
      let activeUser = users.filter(user => user.userId === id)[0];
      activeUser.enabled = enabled;
      let role = [];
      activeUser.roleSet.roleTypes.map((roleType) => {
        role.push(roleType.value);
      })
      activeUser.roleSet = {
        roleTypes: role,
        roleTypeList: role
      }
      showLoader(true);
      putAxiosResponse(APIUrls.UPDATE_ACTIVATION, activeUser)
      .then((res) => {
        if(res.data.status === Constants.SUCCESS) {
          hideModel();
          incrementFilterRequestVersion();
          fetchUsers(currentPage, perPage);
        }
      })
    }

     const columns = [
      {
        id: 'user.name',
        name:  translate("user_management.name"),
        selector: (row, index) => {
          return (
            <div className="flex">
              <div className="w-d100">{row.firstName + ' ' + row.lastName}</div>
              <a href="#" onClick={showRightModel} id={index} className="ml-0">{`${t('settings_view_details')}`}</a>
            </div>
          )
        },
        sortable: true,
        wrap: true,
      },
      {
        id: 'user.role',
        name: translate("user_management.role"),
        selector: (row) => row.roleSet.displayName,
        sortable: true,
      },
      {
        id: 'user.email',
        name: translate("user_management.email"),
        selector: (row) => row.email,
        sortable: true,
      },
      {
        id: 'user.status',
        name:  translate("user_management.status"),
        selector: (row) => {
          return row.enabled ? (
            <span>
              <small className="active-circle"></small>{ translate("user_management.active")}
            </span>
          ) : (
            <span>
              <small className="deactive-circle"></small>{ translate("user_management.inactive")}
            </span>
          );
        },
        sortable: true,
      },
      {
        id: 'user.action',
        name: "Action",
        selector: (row) => {
          return (
            <div className="flex-center">
              <button
                id={"edit-action-" + row.userId}
                aria-label={
                  "Edit details for " + row.firstName + " " + row.lastName
                }
                className="inline-flex mr-15"
                tabIndex={0}
                onClick={(e) => openEditUserProfile(row.userId)}
              >
                <svg
                  className="aaa-change-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="19"
                  height="23"
                  viewBox="0 0 19 23"
                  fill="none"
                >
                  <path
                    d="M5.40458 18.3071H0.651953V13.5525L12.5689 1.67256L12.569 1.67239C12.965 1.27641 13.4916 1.0582 14.0526 1.0582C14.6135 1.0582 15.1401 1.27637 15.5373 1.67352L17.3215 3.45777C17.7187 3.85491 17.9368 4.38152 17.9368 4.94245C17.9368 5.50331 17.7187 6.02985 17.3217 6.42697L17.3215 6.42714L5.40458 18.3071ZM14.1586 3.05207L14.0527 2.9463L13.9467 3.05197L12.1591 4.83397L12.0526 4.94007L12.1589 5.0463L13.9432 6.82943L14.049 6.93523L14.1551 6.82959L15.9438 5.04759L16.0504 4.94146L15.944 4.83519L14.1586 3.05207ZM2.60195 16.2071V16.3571H2.75195H4.53733H4.59932L4.64323 16.3133L12.5621 8.41918L12.6685 8.31312L12.5623 8.20689L10.778 6.42264L10.6721 6.31674L10.5661 6.42247L2.64605 14.3177L2.60195 14.3617V14.424V16.2071ZM0.651953 20.8571H18.352V22.8071H0.651953V20.8571Z"
                    fill="#1D4ED8"
                    stroke="white"
                    strokeWidth="0.3"
                  />
                </svg>
              </button>
              {!row.enabled && row.userId !== owner.id && (
                <button
                  className="inline-flex"
                  title="Activate"
                  id={"activate-action-" + row.userId}
                  aria-label={"Activate " + row.firstName + " " + row.lastName}
                  onClick={(e) => showActivateModel(e, row.userId)}
                  tabIndex={0}
                >
                  <svg
                    className="active-inactive-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_6304_11723)">
                      <path
                        d="M9 7H15M9 11H15M13 15H15M5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21L16 19L14 21L12 19L10 21L8 19L5 21Z"
                        stroke="#1D4ED8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_6304_11723">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              )}
              {row.enabled && row.userId !== owner.id && (
                <button
                  className="inline-flex"
                  id={"deactivate-action-" + row.userId}
                  aria-label={"Deactivate " + row.firstName + " " + row.lastName}
                  onClick={(e) => showModel(e, row.userId)}
                >
                  <svg
                    className="active-inactive-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_6304_11712)">
                      <path
                        d="M5 5V21L8 19L10 21L12 19L14 21L16 19L19 21V19.01M7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V15"
                        stroke="#E42A2A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M11 7H15"
                        stroke="#E42A2A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9 11H11"
                        stroke="#E42A2A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13 15H15"
                        stroke="#E42A2A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15 11V11.01"
                        stroke="#E42A2A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M3 3L21 21"
                        stroke="#E42A2A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_6304_11712">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              )}
            </div>
          );
        },
        sortable: false,
      }
    ];

    const accountStatus = [
      {
        label: "Account Status - All",
        value: Constants.BLANK,
      },
      {
        label: "Active",
        value: true,
      },
      {
        label: "Inactive",
        value: false,
      },
    ];

    useEffect(() => {
      showLoader(true);
      incrementFilterRequestVersion();
      fetchUsers(currentPage, perPage);
      if(!roleArray.includes('ROLE_VENDOR')){
        if(customerBootstrapData?.features?.USER_GROUPS) {
          fetchDepartments();
        }
      fetchUserRoles();
      fetchAccountTargetLanguages();
      fetchConfig();
      }
    }, [currentPage, perPage])

    useEffect(() => {
      $(".lastdisable").trigger("focus");
    }, [])

    useEffect(() => {
      incrementFilterRequestVersion();
      fetchUsers(currentPage, perPage);
    }, [currentPage, perPage, showBulkImportUsers, selectedDepartment, selectedUserRole, selectedReviewLanguage, selectedAccountStatus, nameFilter, emailFilter])



  useEffect(() => {
    const timeoutId = setTimeout(() => {
      let requestVersion = currentFilterRequestVersion;
      getAxiosResponse(APIUrls.ALL_SUB_USERS + filterUrl)
        .then((res) => {
          if (currentFilterRequestVersion === requestVersion) {
            if (res.data.code === 200) {
              let response = res.data.data;
              if (!roleArray.includes('ROLE_VENDOR')) {
                response.resource.result.map((user, index) => {
                  user.roleSet = response.displayName[index]
                })
                setUsers(response.resource.result);
                setTotalRows(response.resource.resultCount);
                setTimeout(() => {
                  if (paginationRef.current) {
                    $('#' + paginationRef.current).trigger('focus');
                    paginationRef.current = '';
                  }
                }, 300);
              } else {
                setUsers(response.result);
                setTotalRows(response.resultCount);
              }
              showLoader(false);
            }
          }
        })
        .catch((err) => {
          handleError(err);
        });

    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [filterUrl])

   
  const fetchUsers = (page, limitPerPage) => {
    let filterUrl = `?page=${page}&limit=${limitPerPage}`;
    if (selectedDepartment.value !== Constants.BLANK)
      filterUrl += `&department=${selectedDepartment.value}`;
    if (selectedUserRole.value !== Constants.BLANK)
      filterUrl += `&role=${selectedUserRole.value}`;
    if (selectedReviewLanguage.value !== Constants.BLANK)
      filterUrl += `&reviewLanguage=${selectedReviewLanguage.value}`;
    if (selectedAccountStatus.value !== Constants.BLANK)
      filterUrl += `&active=${selectedAccountStatus.value}`;
    if (nameFilter !== Constants.BLANK) filterUrl += `&name=${encodeURIComponent(nameFilter)}`;
    if (emailFilter !== Constants.BLANK) filterUrl += `&email=${encodeURIComponent(emailFilter)}`;

    setFilterUrl(filterUrl);
  }

    const fetchDepartments = () => {
      getAxiosResponse(APIUrls.ALL_DEPARTMENT)
      .then((res) => {
        const options = [{label: translate("user_management.department - all"), value: Constants.BLANK}]
        res.data.data.map((department) => (
          options.push({
            label: department.name,
            value: department.id
          })
        ))
        setDepartments(options);
      })
    }
    
    const fetchUserRoles = () => {
      getAxiosResponse(APIUrls.USER_ROLES)
      .then((res) => {
        const options = [{label: translate("user_management.role - all"), value: Constants.BLANK}]
        res.data.data.map((role) => (
          options.push({
            label: role.displayName,
            value: role.value
          })
        ))
        setUserRole(options);
      })
    }

    const fetchAccountTargetLanguages = () => {
      getAxiosResponse(APIUrls.TARGET_LANGUAGE)
      .then((res) => {
        const options = [{label: 'Review Language - All', value: Constants.BLANK}]
        res.data.data.map((language) => (
          options.push({
            label: language.display,
            value: language.code
          })
        ))
        setReviewLanguages(options);
      })
    }

    const fetchConfig = () => {
      getAxiosResponse(APIUrls.GET_CUSTOMER_INFORMATION)
      .then((res) => {
        let enforceUserLimit = res.data.data.enforcesUserLimit
        setCustomerEnforcesUserLimit(enforceUserLimit);
        let roleLimit = res.data.data.useroletypeLimitList
        setRoleTypeLimitList(roleLimit);
        let customerUserLimit
        if (roleLimit) {
          customerUserLimit = roleLimit.filter((limit) => limit.userroletype === "CUSTOMER_USER")?.[0];
        }
        setLimitRemain(!enforceUserLimit || !customerUserLimit || customerUserLimit.limit > customerUserLimit.activeUserCount);
      })
    }

    const filterUsers = (filterType, selectedFilterValue) => {
      showLoader(true);
      if (filterType === Constants.USER_DEPARTMENT_FILTER)
        updateSelectedDepartment(selectedFilterValue);
      if (filterType === Constants.USER_ROLE_FILTER)
        updateSelectedUserRole(selectedFilterValue);
      if (filterType === Constants.USER_REVIEW_LANGUAGE_FILTER)
        updateSelectedReviewLanguage(selectedFilterValue);
      if (filterType === Constants.USER_ACCOUNT_STATUS_FILTER)
        updateSelectedAccountStatus(selectedFilterValue);
      if (filterType === Constants.USER_NAME_FILTER)
        updateNameFilter(selectedFilterValue);
      if (filterType === Constants.USER_EMAIL_FILTER)
        updateEmailFilter(selectedFilterValue);
    }

    const importBulkUsers = (state) => {
      if(state === true) {
        setShowBulkImportUsers(true);
      } else {
        setShowBulkImportUsers(false);
      }
      
    }

    const downloadUsersReport = () => {
      let currentDate = currentDateWithFormat(Constants.DATE_COMPARE_FORMAT);
      downloadFile(
        APIUrls.USER_MANAGEMENT_REPORT,
        "User_Report_" + currentDate + ".xlsx"
      );
    };

    const newUser = () => {
      navigate("/settings/newuser");
    }

    const getUserDisplayName = (roleType) => {
      if(roleType === Constants.ROLE_TYPE_PROJECT_REQUESTER) {
        return `${t('role_display_project_requester')}`;
      } else if(roleType === Constants.ROLE_TYPE_CUSTOMER_USER) {
        return `${t('role_display_customer_user')}`;
      } else if(roleType === Constants.ROLE_TYPE_QUOTE_APPROVER) {
        return `${t('role_display_quote_approver')}`;
      }
    }

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    incrementFilterRequestVersion();
    fetchUsers(page, newPerPage);
  };

    const handlePageChange = (page) => {
      showLoader(true);
      setCurrentPage(page);
      if ($('#pagination-last-page').attr('aria-disabled')==="true") {
        paginationRef.current = $('#pagination-previous-page').attr('id');
      } else if ($('#pagination-first-page').attr('aria-disabled')==="true") {
        paginationRef.current = $('#pagination-next-page').attr('id');
      } else {
        paginationRef.current = document.activeElement.id;
      }

    };
    const noDataFoundComponent = () => {
      return (
        <div className="no-data-display align-center">
          <i className="nodata-icon"></i>
          <p>{Constants.NO_DATA_FOUND}</p>
        </div>
      );
    };

    useEffect(() => {
      if(!loader){
        document.querySelectorAll("div.rdt_TableCol_Sortable").forEach(headerCell => {
          if(headerCell?.dataset?.columnId && headerCell.dataset.columnId === 'user.action') {
            headerCell.setAttribute('tabindex', '-1')
          }
        })

      }
    }, [loader])
    const crumbs = [
      {label:'Settings', url:'settings'},
      {label:'User Management', url:''},
     ];
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap">
            <Breadcrumb crumbs={ crumbs } />
            <div className="user-management-page">
              <div className="project-heading userprofile-heading">
                <h3>
                  {`${t("settings_user_management_title")}`}
                  {customerEnforcesUserLimit && <div
                    className="gb-tooltip"
                    role="tooltip"
                    aria-label="tooltip content"
                    tabIndex="0"
                    aria-expanded="false"
                  >
                    <span>
                      <svg
                        className="aaa-change-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                      >
                        <path
                          d="M12.5003 4.16602C10.8522 4.16602 9.24099 4.65476 7.87058 5.57044C6.50017 6.48611 5.43206 7.7876 4.80133 9.31032C4.1706 10.833 4.00558 12.5086 4.32712 14.1251C4.64866 15.7416 5.44234 17.2265 6.60777 18.3919C7.77321 19.5573 9.25807 20.351 10.8746 20.6726C12.4911 20.9941 14.1666 20.8291 15.6894 20.1983C17.2121 19.5676 18.5136 18.4995 19.4292 17.1291C20.3449 15.7587 20.8337 14.1475 20.8337 12.4993C20.8337 10.2892 19.9557 8.1696 18.3929 6.60679C16.8301 5.04399 14.7105 4.16602 12.5003 4.16602ZM12.5003 19.4438C11.1268 19.4438 9.78421 19.0365 8.6422 18.2734C7.50019 17.5104 6.61011 16.4258 6.0845 15.1569C5.55889 13.8879 5.42137 12.4916 5.68932 11.1446C5.95727 9.79747 6.61867 8.56008 7.58987 7.58889C8.56106 6.61769 9.79845 5.95629 11.1455 5.68834C12.4926 5.42039 13.8889 5.55791 15.1579 6.08352C16.4268 6.60913 17.5114 7.49921 18.2744 8.64122C19.0375 9.78323 19.4448 11.1259 19.4448 12.4993C19.4448 13.4113 19.2652 14.3143 18.9162 15.1569C18.5672 15.9994 18.0556 16.765 17.4108 17.4098C16.7659 18.0547 16.0004 18.5662 15.1579 18.9152C14.3153 19.2642 13.4123 19.4438 12.5003 19.4438Z"
                          fill="#64748B"
                        />
                        <path
                          d="M12.5004 17.0621C12.261 17.0621 12.0314 16.967 11.8621 16.7976C11.6928 16.6283 11.5977 16.3987 11.5977 16.1593V11.9926C11.5977 11.7532 11.6928 11.5236 11.8621 11.3543C12.0314 11.185 12.261 11.0898 12.5004 11.0898C12.7399 11.0898 12.9695 11.185 13.1388 11.3543C13.3081 11.5236 13.4032 11.7532 13.4032 11.9926V16.1593C13.4032 16.3987 13.3081 16.6283 13.1388 16.7976C12.9695 16.967 12.7399 17.0621 12.5004 17.0621Z"
                          fill="#64748B"
                        />
                        <path
                          d="M12.4655 9.73568C13.0408 9.73568 13.5072 9.26931 13.5072 8.69401C13.5072 8.11871 13.0408 7.65234 12.4655 7.65234C11.8902 7.65234 11.4238 8.11871 11.4238 8.69401C11.4238 9.26931 11.8902 9.73568 12.4655 9.73568Z"
                          fill="#64748B"
                        />
                      </svg>
                    </span>
                    <div className="wrap-tooltip-content toptringle-tooltip">
                      <div className="gb-tooltip-content">
                        <div className="triangle"></div>
                        <ul>
                          {roleTypeLimitList.map((roleTypeLimitData, index) => {
                            return (
                              <li key={index}>
                                <small>{getUserDisplayName(roleTypeLimitData.userroletype)} Licence : </small>
                                <strong> {roleTypeLimitData.activeUserCount} out of {roleTypeLimitData.limit} in use</strong>
                              </li>
                            )
                          })}
                        </ul>
                        <a href={"mailto:support@cloudwords.com?subject=" + `${t('customer_user_limit_email_subject')}`}>{`${t('customer_user_limit_email_link')}`}</a>
                      </div>
                    </div>
                  </div>}
                </h3>
                <span>{`${t("settings_user_management_help")}`}</span>
              </div>
              <div className="white-bg">
                {showBulkImportUsers ? <ImportBulkUsers funct={importBulkUsers}/> :
                <><div className="flex flex-center justify-end">
                <ConditionalBlock condition={customerBootstrapData.authenticationType !== 'WELOCALIZE_OKTA'}>
                  <div className="flex two-col border-right">
                    <button className="blue-btn" onClick={() => importBulkUsers(true)}>{`${t("settings_user_management_import_bulk_users")}`}</button>
                  </div>
                  </ConditionalBlock>
                  <div className="flex two-col">
                    <button className="dashboard-btn" onClick={downloadUsersReport}>{`${t("settings_user_management_download_report")}`}</button>
                    <button className="blue-btn active" onClick={newUser} id="new-user" disabled={!limitRemain}>
                      {`${t("user_new")}`}
                      {customerEnforcesUserLimit && <div className="wrap-tooltip-content toptringle-tooltip">
                        <div className="gb-tooltip-content" >
                          <div className="triangle"></div>
                            <ul>
                              {roleTypeLimitList.map((roleTypeLimitData, index) => {
                                if(roleTypeLimitData.userroletype === Constants.ROLE_TYPE_CUSTOMER_USER) {
                                  return (
                                    <li key={index}>
                                      <small>{getUserDisplayName(roleTypeLimitData.userroletype)} Licence : </small>
                                      <strong> {roleTypeLimitData.activeUserCount} out of {roleTypeLimitData.limit} in use</strong>
                                    </li>
                                  )
                                }
                              })}
                            </ul>
                            <a href={"mailto:support@cloudwords.com?subject=" + `${t('customer_user_limit_email_subject')}`}>{`${t('customer_user_limit_email_link')}`}</a>
                        </div>
                      </div>}
                    </button>
                  </div>
                </div>
                {!roleArray.includes('ROLE_VENDOR')? (
                <div className="filter-content flex show-flex">
                  <div className="filter-content-labelHeading">
                    <label htmlFor="department">Department</label>
                  <div className="filter-inline-list department-dw global-dropdown-block">
                    <Select className="global-dropdown-select" classNamePrefix='cw'
                      name="Department"
                      aria-label="Department"
                      placeholder="Department"
                      options={departments}
                      onChange={(value) =>
                        filterUsers(Constants.USER_DEPARTMENT_FILTER, value)
                      }
                      value={departments.filter(function (department) {
                        return department.value === selectedDepartment.value;
                      })}
                      id='department'
                    ></Select>
                  </div>
                  </div>
                  <div className="filter-inline-list">
                  <div className="filter-content-labelHeading">
                    <label htmlFor="name">Name</label>
                    <div className="input-group mb-0">
                      <input
                        type="text"
                        className="form-control-sm"
                        id="name"
                        name="name"
                        onChange={(e) => {
                          filterUsers(
                            Constants.USER_NAME_FILTER,
                            e.target.value
                          );
                        }}
                        
                      />
                    </div>
                    </div>
                    </div>
                  <div className="filter-inline-list">
                  <div className="filter-content-labelHeading">
                    <label htmlFor="email">Email</label>
                    <div className="input-group mb-0">
                      <input
                        type="text"
                        className="form-control-sm"
                        id="email"
                        name="email"
                        onChange={(e) => {
                          filterUsers(
                            Constants.USER_EMAIL_FILTER,
                            e.target.value
                          );
                        }}
                      />
                    </div>
                    </div>
                  </div>
                  <div className="filter-inline-list global-dropdown-block">
                  <div className="filter-content-labelHeading">
                    <label htmlFor="role">Role</label>
                    <Select className="global-dropdown-select" classNamePrefix='cw'
                      name="Role"
                      aria-label="Role"
                      placeholder="Role"
                      options={userRole}
                      onChange={(value) =>
                        filterUsers(Constants.USER_ROLE_FILTER, value)
                      }
                      value={userRole.filter(function (role) {
                        return role.value === selectedUserRole.value;
                      })}
                      id='role'
                    ></Select>
                    </div>
                  </div>
                  <div className="filter-inline-list department-dw global-dropdown-block">
                  <div className="filter-content-labelHeading">
                    <label htmlFor="review-language">Review Language</label>
                    <Select className="global-dropdown-select" classNamePrefix='cw'
                      name="Review Language"
                      aria-label="Review Language"
                      placeholder="Review Language"
                      options={reviewLanguages}
                      onChange={(value) =>
                        filterUsers(
                          Constants.USER_REVIEW_LANGUAGE_FILTER,
                          value
                        )
                      }
                      value={reviewLanguages.filter(function (reviewLanguage) {
                        return (
                          reviewLanguage.value === selectedReviewLanguage.value
                        );
                      })}
                      id="review-language"
                    ></Select>
                    </div>
                  </div>
                  <div className="filter-inline-list global-dropdown-block">
                  <div className="filter-content-labelHeading">
                    <label htmlFor="account-status">Account Status</label>
                    <Select className="global-dropdown-select" classNamePrefix='cw'
                      name="Account Status"
                      aria-label="Account Status"
                      placeholder="Account Status"
                      options={accountStatus}
                      onChange={(value) =>
                        filterUsers(Constants.USER_ACCOUNT_STATUS_FILTER, value)
                      }
                      value={accountStatus.filter(function (status) {
                        return status.value === selectedAccountStatus.value;
                      })}
                      id='account-status'
                    ></Select>
                    </div>
                  </div>
                </div>
                ) : null }
                <div className="global-table datatable-block">
                  <DataTable
                    columns={columns}
                    data={users}
                    progressPending={loader}
                    defaultSortFieldId="user.name"
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationPerPage={perPage}
                    paginationRowsPerPageOptions={[10,15,20,25]}
                    onChangePage={handlePageChange}
                    noDataComponent={noDataFoundComponent()}
                  />
                </div></>}
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className="lightbox-panel" aria-labelledby="deactivate-popup-modal" aria-modal="true" role="dialog">
        <div className="inner-lightbox-panel pb-0" onKeyDown={(e) => traceFocus(e)}>
          <div className="modal-header flex padd-lr">
            <h5 id="deactivate-popup-modal">{userStatus}</h5>
          </div>
          <div className="lightbox-content padd-22">
            <p className="f16-para">{userStatusInfo}</p>
          </div>
          <div className="modal-footer modal-footer-border flex px-22">
            <button className="btn btn-bold cancel-btn" onClick={hideModel} tabIndex={0} id="close-popup">
              {`${t("button_cancel")}`}
            </button>
            <button
              className="btn btn-bold active"
              onClick={() => updateActivation(userStatus, userActivationStatus)}
              tabIndex={0}
              id="active-popup-id"
            >
              {`${t("button_accept")}`}
            </button>
          </div>
        </div>
      </div>

{rightModal?(
      <><div className="overlay rightpopup-conditional"></div><div className="right-modal campaign-right-modal rightpopup-conditional-model" aria-labelledby="right-popup" aria-modal="true" role="dialog">
          <div className="modal-header flex">
            <div className="left flex-center">
              <h2 style={{ marginBottom: '0' }} id="right-popup">Details</h2>
            </div>
            <button
              className="close flex-center"
              aria-label="close"
              onClick={hideRightModel}
              id="close-right-modal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
              >
                <path
                  d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z"
                  fill="white"
                ></path>
                <path
                  d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z"
                  fill="white"
                ></path>
              </svg>
            </button>
          </div>
          <div className="modal-content">
            <div className="management-detail-list gb-gray-list">
              <h5>Departments</h5>
              <ul>
                {viewDetails.length > 0 &&
                  users[viewDetails]?.userGroupMembers?.map((userGroupMember) => {
                    return <li>{userGroupMember.userGroup.name}</li>;
                  })}
              </ul>
            </div>
            <div className="management-detail-list gb-gray-list">
              <h5>Languages to Review</h5>
              {viewDetails.length > 0 &&
                users[viewDetails]?.userLanguages.length > 0 ? (
                <ul>
                  {users[viewDetails]?.userLanguages?.map((userLanguage) => {
                    return <li>{userLanguage.language}</li>;
                  })}
                </ul>
              ) : (
                <div className="not-select">None selected</div>
              )}
            </div>
          </div>
        </div></>
):null
}
    </div>
  );
}
